/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

export const coreTabs = [
    { key: "overview", label: "Overview" },
    { key: "create", label: "Create" },
    { key: "inspect", label: "Inspect" },
    { key: "history", label: "History" }
]